import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterUsersValue,
  UniversalFilterUsersModes,
  UniversalFilterUsersFilterState,
  UniversalFilterUsersOnChange
} from '../../UniversalFilterUsers.types';

interface UniversalFilterUsersFilterStateOptions {
  onChange: UniversalFilterUsersOnChange;
}

function useUniversalFilterUsersFilterState({
  onChange
}: UniversalFilterUsersFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterUsersFilterState) => void
  >(
    (filterState) => {
      // if (filterState?.mode === UniversalFilterUsersModes.IS_NOT_EMPTY) {
      //   onChange({ isNotNull: true });
      //   return;
      // }
      // if (filterState?.mode === UniversalFilterUsersModes.IS_EMPTY) {
      //   onChange({ isNull: true });
      //   return;
      // }

      const userIds = filterState?.userIds;

      if (filterState?.mode === UniversalFilterUsersModes.CONTAINS_ANY_OF) {
        onChange(isEmpty(userIds) ? undefined : userIds);
        return;
      }

      // if (
      //   filterState?.mode === UniversalFilterUsersModes.DOES_NOT_CONTAIN_ANY_OF
      // ) {
      //   onChange(isEmpty(userIds) ? undefined : { notIn: userIds });
      //   return;
      // }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterUsersValue
    ) => UniversalFilterUsersFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue)) {
      return {
        mode: UniversalFilterUsersModes.CONTAINS_ANY_OF,
        userIds: filterValue
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterUsersFilterState;
